import { MonthlyChecklistRepository } from "../../repositories/MonthlyChecklistRepository";

/**
 * Delete Checklist Item Use Case
 */
export class DeleteChecklistItemUseCase {
  constructor(private repository: MonthlyChecklistRepository) {}

  async execute(itemId: number): Promise<void> {
    return await this.repository.deleteChecklistItem(itemId);
  }
}

